import React from "react";

import {
  getRecordStatusClasses,
  normalizeRecordStatus,
} from "../../utils/recordStatus";
import { useTranslation } from "../../i18n/LanguageContext";

type RecordStatusBadgeProps = {
  status: unknown;
  recordType?: string;
  className?: string;
};

export const RecordStatusBadge = ({
                                    status,
                                    recordType = "",
                                    className = "",
                                  }: RecordStatusBadgeProps) => {
  const { t } = useTranslation();
  const normalizedStatus = normalizeRecordStatus(status, recordType);
  const label = {
    PENDING: t('status.pending'),
    COMPLETED: t('status.completed'),
    OK: 'OK',
    CANCELED: t('status.canceled'),
    REFUNDED: t('status.refunded'),
  }[normalizedStatus] || normalizedStatus;

  return (
      <span
          className={`inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-bold ring-1 ring-inset ${getRecordStatusClasses(
              status,
              recordType
          )} ${className}`}
      >
			{label}
		</span>
  );
};
